// Google验证器绑定页面翻译
export default {
  title: "身份验证器绑定",
  description: "为了您的账户安全，请先绑定身份验证器再登录。",

  activationCodeLabel: "激活码",
  steps: {
    step1: "步骤1：打开身份验证器，扫描上方的二维码或输入激活码",
    step2: "步骤2：将身份验证器中的动态数字输入下方的验证码框中进行绑定",
  },

  // 验证码输入
  verification: {
    title: "验证码",
    placeholder: "请输入动态验证码",
    confirm: "确认",
    timeExpired: "验证时间过长，请刷新页面重新登录！",
    success: "身份验证器绑定成功",
  },
};
